import { render } from "./warehouseTransactions.vue?vue&type=template&id=bfd81760&scoped=true"
import script from "./warehouseTransactions.vue?vue&type=script&lang=js"
export * from "./warehouseTransactions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd81760"]])

export default __exports__